import React, { useState, useEffect } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useSelector } from "react-redux";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import QarzibaForm from "./Form";
import Table from "./Table";
import { callApiAsync, postCreateUpdateQarziba, postDeleteQarziba } from "api/apiList";
import { BoolList, DiagnosticCodeCIEList } from "constants/Enums";
import { NotificationManager } from "react-notifications";
import DeleteQarziba from "./Delete";

const QarzibaDialog = ({ open, handleRequestClose, loadQarziba, qarzibaInfo }) => {
  const readOnlyImpactView = useImpactReadOnly();
  const { selectedPrescription } = useSelector(({ management }) => management);
  const [openCRU, setOpenCRU] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [currentRowObj, setCurrentRowObj] = useState(null);
  const msgSuccess = IntlGetText("core.SuccessSave");

  useEffect(() => {
      if (open) loadQarziba();
    }, [open]);

  const handleCreateUpdate = async (data) => {
    await callApiAsync(
      () => postCreateUpdateQarziba(data),
      () => {
        setOpenCRU(false);
        NotificationManager.success(msgSuccess);
        loadQarziba();
      }
    );
  };

const handleDelete = async () => {
  await callApiAsync(
    () => postDeleteQarziba(currentRowObj.id),
    () => {
      setOpenDeleteDialog(false);
      NotificationManager.success(msgSuccess);
      loadQarziba();
    }
  );
};

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      disableBackdropClick
      onClose={handleRequestClose}
    >
      <DialogTitle>
        <IntlMessages id="core.vital.not.available" />
      </DialogTitle>
      <DialogContent>
        <Table
          data={qarzibaInfo}
          handleOpenCRU={() => setOpenCRU(true)}
          handleOpenDel={() => setOpenDeleteDialog(true)}
          setCurrentRowObj={setCurrentRowObj}
          readOnly={readOnlyImpactView}
          DiagnosticCodeCIEList={DiagnosticCodeCIEList()}
        />
        <QarzibaForm
          rowObj={currentRowObj}
          prescriptionId={selectedPrescription?.id}
          openCRU={openCRU}
          handleRequestClose={() => setOpenCRU(false)}
          handleCreateUpdate={handleCreateUpdate}
          qarzibaInfo={qarzibaInfo}
          readOnly={readOnlyImpactView}
          boolList={BoolList()}
          DiagnosticCodeCIEList={DiagnosticCodeCIEList()}
        />
        <DeleteQarziba
          open={openDeleteDialog}
          handleRequestClose={() => setOpenDeleteDialog(false)}
          handleDelete={handleDelete}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleRequestClose} color="secondary">
          <IntlMessages id="core.close" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QarzibaDialog;